import script from "./useAssignedTraining.vue?vue&type=script&lang=js"
export * from "./useAssignedTraining.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__